import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent as fbLogEvent, setUserId, type Analytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

let analytics: Analytics | null = null;
try {
  analytics = getAnalytics(app);
  getPerformance(app);
} catch (_) {
  // Analytics/Performance may fail in some environments
}

export function identifyFirebaseUser(uid: string) {
  if (analytics) setUserId(analytics, uid);
}

export function logEvent(name: string, params?: Record<string, string | number>) {
  if (analytics) fbLogEvent(analytics, name, params);
}
